/*
 * Only allow same-origin, app-relative returnTo targets. Anything else
 * (absolute URLs, protocol-relative URLs, back-slash tricks) falls back to
 * `null` so callers can apply their own default destination.
 *
 * Shared between AuthContainer (the entry point that plants the param)
 * and SettingsPage (the onboarding step that redeems it).
 */
export const sanitizeReturnTo = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  if (!raw.startsWith('/')) return null;
  if (raw.startsWith('//') || raw.startsWith('/\\')) return null;
  return raw;
};

export default sanitizeReturnTo;
